<template>
  <div>
    <base-spinner v-if="loading" />
    <div v-else class="clients-table-container">
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="row align-items-center">
        <div class="col-4 ms-auto">
          <div class="filter-drivers">
            <b-sidebar
              id="sidebar-backdrop"
              :backdrop-variant="variant"
              bg-variant="white"
              backdrop
              :right="!isLangRtl"
              shadow
            >
              <div class="px-3 py-2">
                <h4 class="filter-drivers__head">{{ $t('filter-by') }}</h4>
                <h5 class="filter-input-title">{{ $t('client') }}</h5>
                <hr />
                <base-input
                  type="text"
                  label="english-name"
                  name="english-name"
                  placeholder="english-name"
                  id="filter_client_Name"
                  field="name"
                  :small="true"
                  :value="searchPayload.name"
                  @change-value="setValue"
                ></base-input>
                <base-input
                  type="text"
                  label="name-in-arabic"
                  placeholder="name-in-arabic"
                  id="filter_client_arabicName"
                  field="arabicName"
                  :value="searchPayload.arabicName"
                  @change-value="setValue"
                  :small="true"
                  name="Arabic Name"
                >
                </base-input>
                <base-input
                  type="number"
                  label="phone-number"
                  placeholder="966512345678"
                  name="phone-number"
                  id="filter_client_phoneNumber"
                  field="phoneNumber"
                  :value="searchPayload.phoneNumber"
                  :small="true"
                  @change-value="setValue"
                >
                </base-input>
                <base-select
                  type="text"
                  label="city"
                  name="City"
                  placeholder="select-an-option"
                  id="filter_client_city"
                  field="city"
                  :value="searchPayload.city"
                  :options="$store.getters['enums/city_enums']"
                  :small="true"
                  @change-value="setValue"
                >
                </base-select>
                <base-input
                  type="text"
                  label="contract-id"
                  placeholder="contract-id"
                  id="filter_client_contractorId"
                  field="contractorId"
                  :value="searchPayload.contractorId"
                  :small="true"
                  @change-value="setValue"
                />
                <div class="row mb-2">
                  <!-- CR ISSUE DATE -->
                  <h5 class="filter-input-title pt-2 mt-3 mb-2">
                    {{ $t('cr-issue-date') }}
                  </h5>

                  <!-- From -->
                  <div class="col-6">
                    <div class="form-label label-text">
                      {{ $t('from') }}
                    </div>

                    <div class="input-group">
                      <b-modal
                        id="modalCrIssueDateFrom"
                        ref="modalCrIssueDateFrom"
                        centered
                        hide-header
                        hide-footer
                        no-fade
                        static
                        content-class="w-auto mx-auto"
                      >
                        <b-calendar
                          v-model="searchPayload.crIssueDateFrom"
                          @context="(ctx) => (contextCrIssueDateFrom = ctx)"
                          @input="$refs.modalCrIssueDateFrom.hide()"
                        >
                        </b-calendar>
                      </b-modal>

                      <b-input-group v-b-modal="'modalCrIssueDateFrom'">
                        <label
                          class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                        >
                          <span
                            v-if="!contextCrIssueDateFrom?.selectedYMD"
                            class="time-placeHolder"
                          >
                            {{ $t('select-date') }}
                          </span>

                          {{ contextCrIssueDateFrom?.selectedYMD }}

                          <img
                            :src="require('@/assets/images/icons/select-time.svg')"
                            alt="select time"
                          />
                        </label>
                      </b-input-group>
                    </div>
                  </div>

                  <!-- To -->
                  <div class="col-6">
                    <div class="form-label label-text">
                      {{ $t('to') }}
                    </div>

                    <div class="input-group">
                      <b-modal
                        id="modalCrIssueDateTo"
                        ref="modalCrIssueDateTo"
                        centered
                        hide-header
                        hide-footer
                        no-fade
                        static
                        content-class="w-auto mx-auto"
                      >
                        <b-calendar
                          v-model="searchPayload.crIssueDateTo"
                          @context="(ctx) => (contextCrIssueDateTo = ctx)"
                          @input="$refs.modalCrIssueDateTo.hide()"
                        >
                        </b-calendar>
                      </b-modal>

                      <b-input-group v-b-modal="'modalCrIssueDateTo'">
                        <label
                          class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                        >
                          <span v-if="!contextCrIssueDateTo?.selectedYMD" class="time-placeHolder">
                            {{ $t('select-date') }}
                          </span>

                          {{ contextCrIssueDateTo?.selectedYMD }}

                          <img
                            :src="require('@/assets/images/icons/select-time.svg')"
                            alt="select time"
                          />
                        </label>
                      </b-input-group>
                    </div>
                  </div>
                </div>

                <!-- CR EXPIRY DATE -->
                <div class="row mb-2">
                  <h5 class="filter-input-title pt-2 mt-3 mb-2">
                    {{ $t('cr-expiry-date') }}
                  </h5>

                  <!-- From -->
                  <div class="col-6">
                    <div class="form-label label-text">
                      {{ $t('from') }}
                    </div>

                    <div class="input-group">
                      <b-modal
                        id="modalCrExpiryDateFrom"
                        ref="modalCrExpiryDateFrom"
                        centered
                        hide-header
                        hide-footer
                        no-fade
                        static
                        content-class="w-auto mx-auto"
                      >
                        <b-calendar
                          v-model="searchPayload.crExpiryDateFrom"
                          @context="(ctx) => (contextCrExpiryDateFrom = ctx)"
                          @input="$refs.modalCrExpiryDateFrom.hide()"
                        >
                        </b-calendar>
                      </b-modal>

                      <b-input-group v-b-modal="'modalCrExpiryDateFrom'">
                        <label
                          class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                        >
                          <span
                            v-if="!contextCrExpiryDateFrom?.selectedYMD"
                            class="time-placeHolder"
                          >
                            {{ $t('select-date') }}
                          </span>

                          {{ contextCrExpiryDateFrom?.selectedYMD }}

                          <img
                            :src="require('@/assets/images/icons/select-time.svg')"
                            alt="select time"
                          />
                        </label>
                      </b-input-group>
                    </div>
                  </div>

                  <!-- To -->
                  <div class="col-6">
                    <div class="form-label label-text">
                      {{ $t('to') }}
                    </div>

                    <div class="input-group">
                      <b-modal
                        id="modalCrExpiryDateTo"
                        ref="modalCrExpiryDateTo"
                        centered
                        hide-header
                        hide-footer
                        no-fade
                        static
                        content-class="w-auto mx-auto"
                      >
                        <b-calendar
                          v-model="searchPayload.crExpiryDateTo"
                          @context="(ctx) => (contextCrExpiryDateTo = ctx)"
                          @input="$refs.modalCrExpiryDateTo.hide()"
                        >
                        </b-calendar>
                      </b-modal>

                      <b-input-group v-b-modal="'modalCrExpiryDateTo'">
                        <label
                          class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                        >
                          <span v-if="!contextCrExpiryDateTo?.selectedYMD" class="time-placeHolder">
                            {{ $t('select-date') }}
                          </span>

                          {{ contextCrExpiryDateTo?.selectedYMD }}

                          <img
                            :src="require('@/assets/images/icons/select-time.svg')"
                            alt="select time"
                          />
                        </label>
                      </b-input-group>
                    </div>
                  </div>
                </div>
                <base-input
                  type="text"
                  label="moi-number"
                  placeholder="moi-number"
                  id="filter_client_moiNumber"
                  field="moiNumber"
                  :value="searchPayload.moiNumber"
                  :small="true"
                  @change-value="setValue"
                />

                <!-- <base-select
                  :options="paymentMethodOptions"
                  name="Payment Method"
                  label="payment-method"
                  id="filter_Client_paymentMethod"
                  field="paymentMethod"
                  :value="searchPayload.paymentMethod"
                  @change-value="setValue"
                  :small="true"
                  :useI18n="true"
                >
                </base-select> -->
                <!-- <base-select
                  type="text"
                  label="clients-grade"
                  name="clients grade"
                  placeholder="select-an-option"
                  id="filter_client_clients-grade"
                  field="clientGrade"
                  :value="searchPayload.clientGrade"
                  :options="$store.getters['enums/client_grade_enums']"
                  :small="true"
                  @change-value="setValue"
                >
                </base-select> -->
                <base-input
                  type="text"
                  label="vat-number"
                  name="Vat Number"
                  placeholder="vat-number"
                  id="filter_client_vatNumber"
                  field="vatNumber"
                  :value="searchPayload.vatNumber"
                  :small="true"
                  @change-value="setValue"
                >
                </base-input>
                <base-input
                  type="text"
                  label="contact-person-name"
                  name="Contact Person Name"
                  id="filter_client_contactName"
                  placeholder="contact-person-name"
                  field="contactPersonName"
                  :value="searchPayload.contactPersonName"
                  :small="true"
                  @change-value="setValue"
                >
                </base-input>

                <base-button
                  id="clients_filter_Search"
                  class="search-btn primary mt-4 mb-3"
                  @click="filterBySideBar"
                >
                  {{ $t('search') }}
                </base-button>
                <base-button
                  id="clients_filter_Reset"
                  class="reset-btn mb-1"
                  @click="resetSearchPayload"
                >
                  {{ $t('reset-filters') }}
                </base-button>
              </div>
            </b-sidebar>
          </div>
        </div>
      </div>
      <div class="mt-4" v-if="selected_view === 'table'">
        <div v-if="!group_by_key || group_by_key === 'none'">
          <CommonTable :items="items" :fields="fields" :currentPage="currentPage" />
        </div>
        <div v-else>
          <CommonTable
            :items="[]"
            :fields="fields"
            :currentPage="currentPage"
            tbodyClass="d-none"
            @changeParentSorting="changeParentSorting"
          />
          <div v-for="(each, index) in Object.keys(group_by_data)" :key="index">
            <div class="mb-3 group-by-block cursor-pointer" v-b-toggle="`collapse-group-${index}`">
              <div>
                <span class="label">{{
                  each === 'Debit' || 'Credit' ? $t(each?.toLowerCase()) : each
                }}</span>
                <span class="count"> ({{ group_by_data[each].length }}) </span>
              </div>
              <img
                :src="require(`@/assets/images/icons/accordian-icon.svg`)"
                alt="accordian-icon"
              />
            </div>
            <b-collapse :id="`collapse-group-${index}`">
              <CommonTable
                :items="group_by_data[each]"
                :fields="fields"
                :sortByProp="sortByProp"
                :sortDescProp="sortDescProp"
                :currentPage="currentPage"
                theadClass="d-none"
              >
                <template #cell(status)="data">
                  <span
                    class="status-badge"
                    :class="data.item.status === 'active' ? 'active' : 'inactive'"
                  >
                    {{ $t(data.item.status) }}
                  </span>
                </template>
              </CommonTable>
            </b-collapse>
          </div>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="my-table"
          class="d-flex justify-content-end"
        ></b-pagination>
      </div>
      <div class="row mt-4" v-if="selected_view === 'grid'">
        <div class="col-lg-4 col-md-6 col-xs-12 mb-3" v-for="(item, index) in items" :key="index">
          <div class="grid-block cursor-pointer" @click="routeToDetails(item)">
            <div class="topbar">
              <div>
                <div class="name mb-1">
                  {{ item?.name }}
                </div>
                <div class="name">
                  {{ item?.arabicName }}
                </div>
              </div>
              <div class="d-flex align-items-center">
                <img
                  class="me-2"
                  :src="require('@/assets/images/icons/phone-call.svg')"
                  alt="phone-call"
                />
                <div>
                  {{ item?.phoneNumber }}
                </div>
              </div>
              <div class="d-flex align-items-center">
                <img class="me-2" :src="require('@/assets/images/icons/map.svg')" alt="map" />
                <div>
                  {{ isLangRtl ? item?.city?.arabicName : item?.city?.name || '----' }}
                </div>
              </div>
            </div>
            <div class="content">
              <div class="row mb-3">
                <div class="col" v-if="item?.paymentMethod">
                  <div class="field mb-1">{{ $t('payment-method') }}</div>
                  <div class="value">
                    {{ item?.paymentMethod ? $t(item?.paymentMethod?.toLowerCase()) : '---' }}
                  </div>
                </div>
                <div class="col" v-if="item?.clientGrade?._id">
                  <div class="field mb-1">{{ $t('clients-grade') }}</div>
                  <div class="value d-flex align-items-center">
                    <div class="me-2">
                      {{
                        isLangRtl
                          ? item?.clientGrade?.arabicName
                          : item?.clientGrade?.name || '----'
                      }}
                    </div>
                    <img :src="require('@/assets/images/icons/star.svg')" alt="star" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="my-table"
          class="d-flex justify-content-end"
        ></b-pagination>
      </div>
      <ExpotPopup :paymentMethodOptions="paymentMethodOptions" @exportClient="download" />

      <!-- This is the content you want to convert to PDF -->
      <div id="pdfContent" class="direction-ltr" :style="{ display: pdfContentDisplay }">
        <div class="pdf-container">
          <div>
            <div class="d-flex justify-content-between">
              <div>
                <img src="@/assets/images/eJourney-logo.png" alt="eJourney-logo" width="100px" />
                <div class="currentDate mt-3">{{ currentDate('en') }}</div>
              </div>
              <img
                src="@/assets/images/eJourney-arabic-logo.png"
                alt="eJourney-arabic-logo"
                width="70px"
                height="25px"
              />
            </div>
          </div>
          <hr class="mt-4 mb-4" />
          <div>
            <h6 class="mb-3">Clients Listing</h6>
            <p class="pdf-sub-title">
              Below is a detailed list of our clients, including their contact information and other
              relevant details.
            </p>
          </div>
        </div>
        <b-table
          striped
          class="clients-pdf-table m-0"
          thead-class="table-thead"
          tbody-class="table-tbody"
          :fields="pdfFields"
          :items="pdfItems"
        >
          <template #cell(status)="data">
            <span class="availability-btn green">{{ $t(data.item.status) }}</span>
          </template>

          <template #empty> {{ $t('empty-row') }} </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CommonTable from './CommonTable.vue'
import ExpotPopup from './ExpotPopup.vue'
import ClientService from '@/services/client.service'
import html2pdf from 'html2pdf.js'

export default {
  components: { CommonTable, ExpotPopup },
  props: ['fields', 'searchParamsFromParent', 'selected_view'],
  emits: ['setParentValue'],
  data() {
    return {
      sortBtnHovered: false,
      filterBtnHovered: false,
      error: null,
      loading: false,
      sortDescProp: false,
      perPage: 20,
      currentPage: 1,
      items: [],
      itemsCopy: [],
      sortByProp: '',
      variant: 'transparent',
      contextCrIssueDateFrom: {},
      contextCrIssueDateTo: {},
      contextCrExpiryDateFrom: {},
      contextCrExpiryDateTo: {},
      searchPayload: {
        id: '',
        clientId: '',
        name: '',
        arabicName: '',
        phoneNumber: '',
        vatNumber: '',
        contactPerson: null,
        city: null,
        clientGrade: null,
        paymentMethod: null,
        contractorId: '',
        crExpiryDate: '',
        crIssueDate: '',
        crIssueDateFrom: '',
        crIssueDateTo: '',
        crExpiryDateFrom: '',
        crExpiryDateTo: '',
        moiNumber: '',
        state: null,
        poBox: '',
        attachments: {
          commercialRegistration: null,
          taxCertificate: null,
          zatcaCertificate: null,
          other: [],
        },
      },
      selectedNationality: null,
      rows: 0,
      paymentMethodOptions: [
        { value: null, text: 'please-select-option' },
        {
          value: 'Credit',
          text: 'credit',
        },
        {
          value: 'Debit',
          text: 'debit',
        },
      ],
      quick_search_key: null,
      quick_search_value: null,
      group_by_key: null,
      group_by_data: null,
      pdfContentDisplay: 'none',
      pdfItems: [],
      pdfFields: [
        {
          selected: true,
          key: 'name',
          label: 'English Name',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'arabicName',
          label: 'Arabic Name',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'registrationNumber',
          label: 'Commercial registration number ',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'vatNumber',
          label: 'VAT number',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'phoneNumber',
          label: 'Mobile Number',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'city.name',
          label: 'City',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'paymentMethod',
          label: 'Payment Method',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'clientGrade.name',
          label: 'Client’s Grade',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'contactPerson.name',
          label: 'Contact Name',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'contactPerson.mobileNumber',
          label: 'Contact Phone',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'contactPerson.email',
          label: 'Contact Email',
          sortable: false,
          class: 'w-10',
        },
        {
          selected: true,
          key: 'status',
          label: 'Status',
          sortable: false,
          class: 'w-10',
        },
      ],
    }
  },
  watch: {
    currentPage() {
      this.filterBySideBar()
    },
    selectedNationality(newValue) {
      this.searchPayload.nationality = newValue.code
    },
    items: {
      handler() {
        this.itemsCopy = [...this.items]
        if (this.group_by_key) this.groupByKey(this.group_by_key)
      },
      immediate: true,
    },
  },
  methods: {
    routeToDetails(item) {
      if (!this.$store.getters['enums/is_not_permitted']('editClient'))
        this.$router.push(`/client/${item?.clientId}`).catch(() => {})
    },
    openDeleteModel(id) {
      this.$bvModal.show(`delete-client-modal-${id}`)
    },
    closeModel(id) {
      this.$bvModal.hide(`delete-client-modal-${id}`)
    },
    setValue(val, field) {
      if (field.includes('.')) {
        const keys = field.split('.')
        this.searchPayload[keys[0]][keys[1]] = val
      } else {
        this.searchPayload[field] = val
      }
    },
    quickSearch(key, value) {
      this.quick_search_key = key
      this.quick_search_value = value
      this.filterBySideBar()
    },
    filterBySideBar() {
      this.loading = true

      let params = new URLSearchParams()
      params.append('page', this.currentPage)
      params.append('limit', this.perPage)
      params.append('sort', '-updated_on')

      if (this.quick_search_key && this.quick_search_value)
        params.append(this.quick_search_key, '*' + this.quick_search_value + '*')

      if (this.searchPayload.name) params.append('name', '*' + this.searchPayload.name + '*')

      if (this.searchPayload.arabicName)
        params.append('arabicName', '*' + this.searchPayload.arabicName + '*')

      if (this.searchPayload.vatNumber)
        params.append('vatNumber', '*' + this.searchPayload.vatNumber + '*')

      if (this.searchPayload.phoneNumber)
        params.append('phoneNumber', '*' + this.searchPayload.phoneNumber + '*')

      if (this.searchPayload.contactPerson)
        params.append('contactPerson.name', this.searchPayload.contactPerson)

      if (this.searchPayload.paymentMethod)
        params.append('paymentMethod', this.searchPayload.paymentMethod)

      if (this.searchPayload.city) params.append('city', this.searchPayload.city)

      if (this.searchPayload.clientGrade)
        params.append('clientGrade', this.searchPayload.clientGrade)
      if (this.searchPayload.clientId) params.append('clientId', this.searchPayload.clientId)

      if (this.searchPayload.crIssueDateFrom) {
        params.append(
          'crIssueDate',
          `gte:${new Date(this.searchPayload.crIssueDateFrom).toISOString()}`
        )
      }

      if (this.searchPayload.crIssueDateTo) {
        params.append(
          'crIssueDate',
          `lte:${new Date(this.searchPayload.crIssueDateTo).toISOString()}`
        )
      }

      if (this.searchPayload.crExpiryDateFrom) {
        params.append(
          'crExpiryDate',
          `gte:${new Date(this.searchPayload.crExpiryDateFrom).toISOString()}`
        )
      }

      if (this.searchPayload.crExpiryDateTo) {
        params.append(
          'crExpiryDate',
          `lte:${new Date(this.searchPayload.crExpiryDateTo).toISOString()}`
        )
      }
      if (this.searchPayload.moiNumber) {
        params.append('moiNumber', String(this.searchPayload.moiNumber))
      }

      const attachments = this.searchPayload.attachments

      if (attachments?.commercialRegistration) {
        params.append('attachments.commercialRegistration', attachments.commercialRegistration)
      }

      if (attachments?.taxCertificate) {
        params.append('attachments.taxCertificate', attachments.taxCertificate)
      }

      if (attachments?.zatcaCertificate) {
        params.append('attachments.zatcaCertificate', attachments.zatcaCertificate)
      }

      if (attachments?.other?.length) {
        attachments.other.forEach((file, index) => {
          params.append(`attachments.other[${index}]`, file)
        })
      }
      params.append(
        'select',
        'poBox,attachments.commercialRegistration,attachments.taxCertificate,attachments.zatcaCertificate,attachments.other,faxNumber,_id,city.name,city.arabicName,clientGrade.name,clientGrade.arabicName,name,arabicName,phoneNumber,email,registrationNumber,paymentMethod,poiNumber,vatNumber,crIssueDate,crExpiryDate,moiNumber,contactPerson.name,contactPerson.arabicName,contactPerson.mobileNumber,contactPerson.email,contactPerson.attorneyNumber'
      )

      ClientService.search(params)
        .then((response) => {
          console.log('API RESPONSE:', response)

          const data =
            response.items?.map((each) => {
              console.log(each.contactPerson)
              return {
                id: each?.idNumber,
                clientId: each?._id,
                city: this.isLangRtl ? each?.city?.arabicName : each?.city?.name,
                clientGrade: this.isLangRtl
                  ? each?.clientGrade?.arabicName
                  : each?.clientGrade?.name || '----',
                name: each?.name,
                arabicName: each?.arabicName,
                phoneNumber: each?.phoneNumber,
                email: each?.email || '---',
                registrationNumber: each?.registrationNumber || '---',
                vatNumber: each?.vatNumber || '---',
                paymentMethod: each?.paymentMethod,
                poiNumber: each?.poiNumber,
                crExpiryDate: each?.crExpiryDate,
                crIssueDate: each?.crIssueDate,
                moiNumber: each?.moiNumber,
                attachments: {
                  commercialRegistration:
                    each?.attachments?.commercialRegistration || each?.commercialRegistration,
                  taxCertificate: each?.attachments?.taxCertificate || each?.taxCertificate,
                  zatcaCertificate: each?.attachments?.zatcaCertificate || each?.zatcaCertificate,
                },
                faxNumber: each?.faxNumber,
                poBox: each?.poBox,
                contactPerson: this.isLangRtl
                  ? each?.contactPerson?.arabicName
                  : each?.contactPerson?.name || '---',

                contactPersonMobile: each?.contactPerson?.mobileNumber || '---',
                contactPersonEmail: each?.contactPerson?.email || '---',
                attorneyNumber:
                  each?.contactPerson?.find((c) => c.type === 'Authorized')?.attorneyNumber ||
                  '---',
                status: 'active',
              }
            }) || []

          console.log('MAPPED DATA:', data)

          this.items = data
          this.rows = response.total
          this.$emit('getAvailableLengths', this.rows)
          this.loading = false
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetSearchPayload() {
      this.searchPayload.city = null
      this.searchPayload.clientGrade = null
      this.searchPayload.name = ''
      this.searchPayload.arabicName = ''
      this.searchPayload.vatNumber = ''
      this.searchPayload.phoneNumber = ''
      this.searchPayload.contactPersonName = ''
      this.searchPayload.paymentMethod = null
      this.searchPayload.contractorId = ''
      this.searchPayload.crExpiryDate = ''
      this.searchPayload.crIssueDate = ''
      this.searchPayload.moiNumber = ''
      this.searchPayload.status = null
      this.searchPayload.crIssueDateFrom = ''
      this.searchPayload.crIssueDateTo = ''
      this.searchPayload.crExpiryDateFrom = ''
      this.searchPayload.crExpiryDateTo = ''
      this.filterBySideBar()
    },
    groupByKey(key) {
      this.group_by_key = key
      this.group_by_data = key === 'none' ? null : this.groupBy(this.items, key)
    },
    changeParentSorting(sortBy, sortDesc) {
      this.sortByProp = sortBy
      this.sortDescProp = sortDesc
    },
    showExportPopup() {
      this.$bvModal.show('client-export-modal')
    },
    download(payload) {
      this.$emit('setParentValue', 'export_loading', true)
      this.$emit('setParentValue', 'export_error', null)

      let params = new URLSearchParams()

      if (payload.paymentMethod) params.append('paymentMethod', payload.paymentMethod)

      if (payload.city) params.append('city', payload.city)

      if (payload.clientGrade) params.append('clientGrade', payload.clientGrade)

      if (payload.type) params.append('type', payload.type)

      if (payload.fileType === 'Excel') {
        ClientService.download(params)
          .then((res) => {
            this.downloadFile(
              res,
              `clients-${moment().locale('en').utcOffset(0).format('DD-MM-YYYY')}.xlsx`
            )
          })
          .catch(({ message }) => {
            this.$emit('setParentValue', 'export_error', message)
          })
          .finally(() => {
            this.$emit('setParentValue', 'export_loading', false)
          })
      } else {
        // fileType is PDF

        this.pdfContentDisplay = 'none'
        params.append(
          'select',
          'poBox,commercialRegistrationAttachment,taxCertificateAttachment,zatcaCertificateAttachment,idNumber,_id,city.name,clientGrade.name,type,name,arabicName,phoneNumber,email,registrationNumber,vatNumber,contactPerson.name,contactPerson.mobileNumber,contactPerson.email,paymentMethod,type'
        )

        ClientService.search(params)
          .then(({ items }) => {
            this.pdfItems = items.map((item) => ({ ...item, status: 'active' }))

            this.pdfContentDisplay = 'block'
            const element = document.getElementById('pdfContent')
            const pdfOptions = {
              margin: [0.2, 0.2, 0.2, 0.2],
              filename: 'clients_list.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { scale: 2, useCORS: true },
              jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
            }

            let pdfUrl
            html2pdf()
              .set(pdfOptions)
              .from(element)
              .toPdf()
              .get('pdf')
              .then(function (pdf) {
                pdf.setProperties({
                  title: 'clients',
                  subject: 'clients',
                  author: 'clients',
                  keywords: 'pdf, document',
                })
                pdfUrl = pdf.output('bloburl')
                return pdfUrl
              })
              .then((pdfUrl) => {
                const url = pdfUrl
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'clients')
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.$emit('setParentValue', 'export_loading', false)
              })
          })
          .catch(({ message }) => {
            this.$emit('setParentValue', 'export_error', message)
          })
          .finally(() => {
            this.pdfContentDisplay = 'none'
          })
      }
    },
  },
  mounted() {
    this.filterBySideBar()
  },
  created() {
    this.$store.dispatch('enums/GET_CITY_ENUMS')
    this.$store.dispatch('enums/GET_CLIENT_GRADE_ENUMS')
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/clients.json'),
      ar: require('@/services/i18n/locales/ar/clients.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-block {
  .topbar {
    border-radius: 0.5rem 0.5rem 0rem 0rem;
    background: var(--color-84);
    display: flex;
    padding: 0.4375rem 1rem;
    justify-content: space-between;
    align-items: center;
    color: var(--color-61);
    font-size: 0.75rem;

    .name {
      font-size: 0.875rem;
      font-weight: 700;
    }
  }

  .content {
    height: 160px;
    padding: 1rem 1rem 0.5rem 1rem;
    border-radius: 0rem 0rem 0.25rem 0.25rem;
    border: 1px solid var(--color-84);
    background: var(--color-01);

    .field {
      color: var(--color-109);
      font-size: 0.75rem;
    }

    .value {
      color: var(--color-61);
      font-size: 0.875rem;
      font-weight: 700;
    }
  }
}

.currentDate {
  color: var(--color-02);
  font-size: 12px;
}

.pdf-sub-title {
  font-size: 10px;
}
</style>
<style lang="scss">
.clients-pdf-table {
  th,
  td {
    padding: 0px !important;
    padding-inline: 4px 2px !important;
    padding-block: 4px !important;
    border-bottom: 1px solid #dee2e6;
    place-content: center;
    text-align: center;
  }

  th {
    background: var(--color-04) !important;
    color: var(--color-13);
    font-size: 7px;
  }

  td {
    text-wrap: nowrap;
    font-size: 6px;
    height: 50px !important;
  }

  .availability-btn {
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.4px;
    border-color: transparent;
    padding: 7px 10px;
    border-radius: 10px;
    width: 105px;
    display: inline-block;
  }

  .availability-btn.green {
    color: var(--color-06);
    background-color: var(--color-19);
  }
}
</style>
